import { render, staticRenderFns } from "./ItemDaTabelaDeFechamento.vue?vue&type=template&id=775f643c&scoped=true&"
import script from "./ItemDaTabelaDeFechamento.vue?vue&type=script&lang=ts&"
export * from "./ItemDaTabelaDeFechamento.vue?vue&type=script&lang=ts&"
import style0 from "./ItemDaTabelaDeFechamento.vue?vue&type=style&index=0&id=775f643c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f643c",
  null
  
)

export default component.exports